import styled from "styled-components";

export const SectionContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 100px auto 0;
  display: flex;
  justify-content: space-between;
  letter-spacing: -1px;
  h2 {
    font-size: 30px;
    font-weight: 800;
    margin-bottom: 60px;
  }
  &.theme-2 {
    max-width: 1240px;
  }
  > div:nth-child(2) {
    width: calc(100% - 290px);
    margin-bottom: 50px;
  }
  @media screen and (max-width: 1050px) {
    margin: 50px auto 0;
    h2 {
      font-size: 26px;
      margin-bottom: 40px;
    }
    > div:nth-child(2) {
      width: calc(100% - 200px);
    }
  }
  @media screen and (max-width: 767px) {
    display: block;
    letter-spacing: normal;
    margin-bottom: 50px;
    h2 {
      font-size: 20px;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      gap: 5px;
      button {
        background: transparent;
        color: rgba(0, 0, 0, 0.5);
        svg {
          display: block;
          margin: auto;
        }
      }
    }
    > div:nth-child(2) {
      width: 100%;
    }
  }
`;

export const ProductListContainer = styled.ul`
  li {
    display: flex;
    align-items: center;
    min-height: 70px;
    text-align: center;
    border-bottom: 1px solid #eee;
    padding: 20px 0;
    gap: 10px;
    font-size: 16px;
    flex-wrap: wrap;
    &.not {
      padding: 20px;
      border-bottom: 1px solid #000;
    }
    &.header {
      font-weight: 700;
    }
    &.companyName {
      font-size: 20px;
    }
    img {
      max-width: 100%;
      width: 100px;
      aspect-ratio: 1;
      border: 1px solid #eee;
      border-radius: 5px;
    }
    button svg {
      display: block;
      margin: auto;
    }
    label {
      width: 5%;
    }
    .media {
      width: 15%;
      img {
        cursor: pointer;
      }
    }
    .name {
      width: calc(60% - 186px);
      cursor: pointer;
      strong {
        display: block;
        font-weight: normal;
      }
      span {
        color: #999;
        font-size: 14px;
      }
    }
    .counter {
      width: 15%;
    }
    .price {
      width: 15%;
    }
    .delete {
      width: 5%;
      font-size: 22px;
      max-width: 80px;
      border-radius: 5px;
      height: 34px;
      background: transparent;
    }
    .edit {
      width: 100%;
      height: 34px;
      border: 1px solid #eee;
      border-radius: 5px;
      background: transparent;
      font-size: 14px;
    }
    &:not(.header) {
      .name {
        text-align: left;
      }
      .counter {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 136px;
        span {
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          height: 34px;
          line-height: 34px;
          width: 68px;
        }
        button {
          border: 1px solid #eee;
          background: transparent;
          height: 34px;
          width: 34px;
          border-radius: 50%;
          &:first-child {
            transform: translateX(50%);
          }
          &:last-child {
            transform: translateX(-50%);
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
  }
  @media screen and (max-width: 767px) {
    li {
      flex-wrap: wrap;
      position: relative;
      padding: 10px 0;
      font-size: 14px;
      &.header {
        justify-content: space-between;
        font-weight: normal;
        label {
          margin-right: 10px;
        }
        button {
          border: none;
          background: transparent;
          color: #8f908f;
          &:not(:last-child) {
            margin-right: 10px;
          }
        }
      }
      &.companyName {
        font-weight: 700;
        font-size: 18px;
      }
      label {
        width: 20px;
      }
      .media {
        order: 2;
        width: 60px;
      }
      .name {
        order: 1;
        width: calc(100% - 30px);
        font-weight: 500;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .box {
        width: calc(100% - 80px);
        order: 3;
        .price {
          display: block;
          text-align: left;
          width: 100%;
          font-weight: 700;
        }
        .counter {
          width: 100%;
          margin-top: 5px;
          justify-content: flex-start;
          font-size: 14px;
          span {
            line-height: 30px;
            height: 30px;
            width: 50px;
          }
          button {
            width: 30px;
            height: 30px;
            border-radius: 0%;
            &:first-child,
            &:last-child {
              transform: none;
            }
          }
        }
      }
      button.delete {
        position: absolute;
        top: 10px;
        right: 0;
        background: transparent;
        font-size: 24px;
        color: #000;
        width: 24px;
        height: 24px;
        border: none;
      }
      .edit {
        order: 4;
      }
    }
  }
`;

export const CustomCheckbox = styled.label`
  cursor: pointer;
  input[type="checkbox"] {
    display: none;
  }
  input[type="checkbox"]:checked ~ span {
    background: #f01e1e;
    border-color: #f01e1e;
    &::after {
      border-color: #fff;
    }
  }
  span {
    width: 20px;
    height: 20px;
    display: inline-block;
    border: 1px solid #ccc;
    position: relative;
    border-radius: 50%;
    transition: 0.3s;
    &::after {
      content: "";
      transition: 0.3s;
      position: absolute;
      width: 11px;
      height: 7px;
      border-left: 2px solid #ccc;
      border-bottom: 2px solid #ccc;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%) rotate(-45deg);
    }
  }
`;

export const SideMenuContainer = styled.div`
  width: 250px;
  min-height: 1000px;
  border-right: 1px solid #eaeaea;
  h2 {
    cursor: pointer;
  }
  .section {
    margin-bottom: 30px;
    p {
      font-weight: 700;
      margin-bottom: 20px;
    }
    ul li {
      width: fit-content;
      margin-bottom: 20px;
      cursor: pointer;
      color: #666;
      position: relative;
      &:last-child {
        margin-bottom: 0;
      }
      &.active {
        color: #000;
      }
      &.active,
      &:hover {
        &::after {
          width: 100%;
        }
      }
      &::after {
        content: "";
        width: 0;
        height: 1px;
        transition: 0.3s;
        background: #666;
        transition: 0.3s;
        position: absolute;
        top: 110%;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  @media screen and (max-width: 1050px) {
    width: 160px;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    min-height: auto;
    margin-bottom: 56px;
    border-right: none;
    .section p {
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #000;
    }
    .section ul li {
      width: 100%;
      border-bottom: 1px solid #eaeaea;
      margin-bottom: 10px;
      padding-bottom: 10px;
      &::after {
        display: none;
      }
      &:hover {
        color: #000;
      }
      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
`;

export const ShopDashboardContainer = styled.div`
  button.wish {
    display: flex;
    align-items: center;
    gap: 5px;
    svg {
      display: block;
      margin: auto;
    }
  }
  .statuses {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 195px;
    border: 1px solid #111;
    border-radius: 25px;
    margin-bottom: 18px;
    div {
      width: 25%;
      text-align: center;
      position: relative;
      &:not(:last-child)::after {
        content: ">";
        display: inline-block;
        transform: scaleY(2) translateX(50%);
        position: absolute;
        top: 50%;
        right: 0;
        color: #ccc;
      }
      span {
        display: block;
        margin-bottom: 26px;
      }
      strong {
        font-size: 32px;
        font-weight: 700;
      }
    }
  }
  .afterStatuses {
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background: #fafafa;
    border-radius: 25px;
    margin-bottom: 56px;
    div {
      width: calc(100% / 3);
      text-align: center;
      position: relative;
      &:not(:last-child)::after {
        content: "";
        width: 1px;
        height: 80%;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background: #ddd;
      }
      strong {
        display: inline-block;
        color: #999;
        margin-left: 42px;
      }
    }
  }
  .products {
    margin-top: 33px;
    margin-bottom: 80px;
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    li {
      width: calc((100% - 90px) / 4);
      &.not {
        width: 100%;
      }
      cursor: pointer;
      img {
        width: 100%;
        aspect-ratio: 1;
        overflow: hidden;
        object-fit: cover;
        outline: 1px solid #d9d9d9;
        border-radius: 5px;
      }
      strong {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 600;
        margin: 30px 0 10px;
        display: block;
      }
    }
  }
  @media screen and (max-width: 1050px) {
  }
  @media screen and (max-width: 767px) {
    .statuses {
      height: 88px;
      div {
        span {
          margin-bottom: 10px;
        }
        strong {
          font-size: 20px;
        }
      }
    }
    .afterStatuses {
      height: 60px;
    }
    .products {
      gap: 20px;
      li {
        width: calc(50% - 10px);
        strong {
          margin: 10px 0 0;
        }
      }
    }
  }
`;

export const SectionHeaderContainer = styled.div`
  padding-bottom: 24px;
  &.line {
    border-bottom: 1px solid #222;
  }
  &.btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tit {
    display: flex;
    align-items: baseline;
    gap: 10px;
    strong {
      font-size: 22px;
      font-weight: 600;
    }
    span,
    button {
      font-size: 14px;
      color: #666;
    }
    button {
      display: flex;
      align-items: center;
      gap: 5px;
      svg {
        display: block;
        margin: 0;
      }
    }
  }
  svg {
    display: block;
    margin: 0;
  }
  button {
    background: transparent;
    &.wish {
      color: #d3233a;
      font-size: smaller;
    }
    &.addr {
      width: 120px;
      height: 40px;
      font-size: 16px;
      border: 1px solid #111;
      border-radius: 5px;
    }
  }
  @media screen and (max-width: 1050px) {
    .tit {
      strong {
        font-size: 18px;
      }
      span {
        font-size: 14px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    padding-bottom: 10px;
    .tit {
      strong {
        font-size: 14px;
      }
      span {
        font-size: 12px;
      }
    }
    button.wish,
    button.addr {
      font-size: 12px;
    }
  }
`;

export const WishlistContainer = styled.div`
  .actions {
    display: flex;
    justify-content: space-between;
    margin-top: 33px;
    div {
      &:nth-child(2) button:first-child {
        border-color: #f01e1e;
        background: #f01e1e;
        color: #fff;
      }
      button {
        width: 110px;
        height: 40px;
        border-radius: 10px;
        font-size: 14px;
        border: 1px solid #eaeaea;
        background: transparent;
        &:not(:last-child) {
          margin-right: 5px;
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
  }
  @media screen and (max-width: 767px) {
    .actions div {
      width: 100%;
      button {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
`;

export const CartContainer = styled.div`
  .orderSummary {
    display: flex;
    justify-content: space-between;
    margin-top: 33px;
    .left {
      div {
        button {
          width: 110px;
          height: 40px;
          border-radius: 10px;
          font-size: 14px;
          border: 1px solid #eaeaea;
          background: transparent;
          &:not(:last-child) {
            margin-right: 5px;
          }
        }
      }
      ul {
        margin-top: 26px;
        li {
          position: relative;
          padding-left: 10px;
          font-size: 14px;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
          &::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            width: 4px;
            height: 4px;
            background: #111;
            border-radius: 50%;
          }
        }
      }
    }
    .right {
      width: 50%;
      max-width: 400px;
      padding: 20px;
      border: 1px solid #eaeaea;
      border-radius: 10px;
      height: 260px;
      display: flex;
      flex-direction: column;
      div {
        margin-bottom: 20px;
        &:last-of-type {
          border-top: 1px solid #eaeaea;
          padding-top: 20px;
          span:last-child {
            font-size: 22px;
            font-weight: 700;
          }
        }
        span {
          width: 50%;
          display: inline-block;
          font-size: 16px;
          &:first-child {
          }
          &:last-child {
            text-align: right;
          }
        }
      }
      button {
        width: 100%;
        height: 60px;
        margin-top: auto;
        background: #d3233a;
        border-radius: 10px;
        color: #fff;
      }
    }
  }
  @media screen and (max-width: 1050px) {
  }
  @media screen and (max-width: 767px) {
    .orderSummary {
      flex-direction: column-reverse;
      margin-top: 10px;
      .left,
      .right {
        width: 100%;
        max-width: none;
      }
      .left {
        .actions {
          display: none;
        }
        ul {
          margin-top: 56px;
          li {
            color: #777;
            &::after {
              background: #777;
            }
          }
        }
      }
      .right {
        border: none;
        padding: 0;
        height: auto;
        display: block;
        div {
          margin-bottom: 10px;
          span {
            font-size: 14px;
          }
          &:last-of-type span:last-child {
            font-size: 18px;
          }
        }

        button {
          margin-top: 20px;
          height: 50px;
          font-size: 16px;
        }
      }
    }
  }
`;

export const OrderHistoryContainer = styled.div`
  .dateForm {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    background: #f8f8f8;
    padding: 20px;
    margin-bottom: 80px;
    .periods {
      width: calc(50% - 55px);
      button {
        width: 25%;
        height: 50px;
        background: #ffffff;
        border: 1px solid #e4e4e4;
        &:first-child {
          border-radius: 5px 0 0 5px;
        }
        &:last-child {
          border-radius: 0 5px 5px 0;
        }
        &:not(:last-child) {
          border-right: none;
        }
        &.active {
          border-color: #d3233a;
          background: #d3233a;
          color: #fff;
        }
      }
    }
    .dateRange {
      width: calc(50% - 55px);
      display: flex;
      align-items: center;
      input {
        width: 100%;
        width: 48%;
        height: 100%;
        height: 50px;
        background: #ffffff;
        border: 1px solid #e4e4e4;
        padding: 10px;
        border-radius: 5px;
        color: #828482;
        cursor: pointer;
        &:focus {
          border: 1px solid #e4e4e4 !important;
          box-shadow: none;
          outline: none;
        }
      }
      p {
        width: 4%;
        text-align: center;
      }
      span {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        color: #aaaaaa;
        svg {
          display: block;
          margin: 0;
          font-size: 24px;
        }
      }
    }
    > button {
      width: 70px;
      height: 50px;
      border: 1px solid #222222;
      border-radius: 5px;
      background: #fff;
      color: #828482;
    }
  }
  > ul {
    margin-top: 30px;
  }
  @media screen and (max-width: 1050px) {
    .dateForm {
      flex-wrap: wrap;
      .periods {
        width: 100%;
      }
      .dateRange {
        width: calc(100% - 90px);
        input {
          padding: 0 10px;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .dateForm {
      padding: 0;
      background: transparent;
      gap: 10px;
      margin-bottom: 56px;
      .periods button,
      .dateRange input,
      > button {
        height: 30px;
      }
      .dateRange {
        width: calc(100% - 80px);
      }
      > button {
        color: #000;
      }
    }
  }
`;

export const OrderGroupContainer = styled.div`
  &:not(:last-child) {
    margin-bottom: 30px;
  }
  .orderInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    p {
      font-size: 20px;
      strong {
        display: inline-block;
        margin-right: 10px;
      }
      span {
        color: #777;
      }
    }
    button {
      color: #d3233a;
      background: transparent;
    }
  }
  .companies {
    border: 1px solid rgb(238, 238, 238);
    border-radius: 10px;
    padding: 20px;
    .company {
      &:not(:last-child) {
        margin-bottom: 30px;
      }
    }
    .companyName {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      gap: 10px;
      span {
        width: fit-content;
        &:nth-child(1) {
          cursor: pointer;
          font-weight: 700;
          font-size: 24px;
        }
        &.ordered,
        &.confirmed,
        &.preparing {
          color: #999;
        }
        &.shipped,
        &.delivered,
        &.completed {
          color: #222;
        }

        &.cancelled,
        &.returned,
        &.refunded {
          color: #d3233a;
        }
      }
    }
    li {
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &:not(:last-child) {
        margin-bottom: 15px;
      }
      .content,
      .actions {
        padding: 20px;
      }
      .content {
        width: calc(100% - 200px);
        border-right: 1px solid #eee;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        .deliveryInfo {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 10px;
          span {
            &:nth-child(1) {
              color: #d3233a;
              font-weight: 700;
              position: relative;
            }
            &:nth-of-type(2) {
              color: #333;
            }
          }
          i {
            width: 5px;
            height: 5px;
            background: #ddd;
            border-radius: 50%;
          }
        }
        img {
          width: 80px;
          height: 80px;
          border-radius: 5px;
          cursor: pointer;
        }
        .info {
          width: calc(100% - 90px);
          font-size: 16px;
          .productName {
            width: fit-content;
            cursor: pointer;
          }
          p {
            margin-bottom: 5px;
            &:nth-child(2) {
              color: #777;
            }
          }
        }
      }
      .actions {
        width: 200px;
        text-align: center;
        border-left: 1px solid #eee;
        margin-left: -1px;
        button {
          width: 160px;
          border: 1px solid #ddd;
          background: transparent;
          width: 160px;
          height: 36px;
          border-radius: 5px;
          font-size: 14px;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .orderInfo {
      margin-bottom: 15px;
    }
    .companies {
      padding: 15px;
      .companyName span:nth-child(1) {
        font-size: 18px;
      }
    }
    .companies li {
      .content,
      .actions {
        padding: 15px;
      }
      .content {
        width: 100%;
        border: none;
        .info {
          font-size: 16px;
        }
      }
      .actions {
        border-top: 1px solid #eee;
        border-left: none;
        width: 100%;
        margin-left: 0;
        display: flex;
        justify-content: center;
        gap: 10px;
        button {
          width: calc((100% - 20px) / 3);
          &:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .orderInfo p {
      font-size: 16px;
    }
    strong {
      display: block;
    }
    .companies li {
      position: relative;
      .content {
        .deliveryInfo {
          width: calc(100% - 90px);
        }
        .deliveryInfo ~ button {
          width: 80px;
          height: 25px;
          border: 1px solid #ccc;
          background: transparent;
          border-radius: 5px;
          font-size: 10px;
        }
        img {
          width: 50px;
          height: 50px;
        }
        .info {
          width: calc(100% - 60px);
          font-size: 14px;
          p {
            margin-bottom: 0;
            &:nth-child(2) {
              font-size: 12px;
            }
          }
        }
      }
      .actions {
        padding: 10px;
        button {
          width: 100%;
          max-width: calc(50% - 5px);
          height: 30px;
          font-size: 12px;
        }
      }
    }
  }
`;

export const OrderDetailContainer = styled.div`
  .contents {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    margin-top: 30px;
  }
  .section {
    &:nth-child(1) {
      width: 100%;
    }
    &:nth-child(2),
    &:nth-child(3) {
      width: calc(50% - 20px);
      align-items: stretch;
      ul {
        height: calc(100% - 46px);
      }
    }
    .label {
      font-size: 22px;
      margin-bottom: 20px;
      font-weight: 700;
      display: block;
    }
    &:nth-child(2) ul li:last-child {
      min-height: 60px;
    }
    &:nth-child(3) ul li.highlight {
      font-weight: 700;
    }
    &:nth-child(2),
    &:nth-child(3) {
      ul {
        border: 1px solid #eee;
        padding: 20px;
        font-size: 16px;
        border-radius: 10px;
        li {
          min-height: 20px;
          margin-bottom: 20px;
          display: flex;
          align-items: flex-start;
          &:last-child {
            margin-bottom: 0;
          }
          span {
            display: inline-block;
            &:first-child {
              width: 100px;
            }
            &:last-child {
              width: calc(100% - 100px);
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .section {
      .label {
        font-size: 18px;
      }
    }
    .contents {
      display: block;
      .section:nth-child(2) {
        margin: 56px 0;
      }
      .section:nth-child(2),
      .section:nth-child(3) {
        width: 100%;
        ul {
          height: auto;
          li {
            min-height: auto;
          }
        }
      }
      .section:nth-child(2) ul li:last-child {
        min-height: none;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .section:nth-child(2),
    .section:nth-child(3) {
      .label {
        font-size: 16px;
        margin-bottom: 10px;
      }
      ul {
        font-size: 14px;
        padding: 10px;
        li {
          margin-bottom: 5px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
`;

export const TextInput = styled.input`
  border-radius: 10px;
  border: 1px solid #ededed;
  height: 52px;
  padding: 0 20px;
  &[type="text"]:focus,
  &[type="password"]:focus {
    border: 1px solid #ededed !important;
    box-shadow: none;
  }
  &[type="text"][readonly] {
    background-color: #fafafa;
    color: #a8aaa8;
    cursor: default;
  }
  @media screen and (max-width: 767px) {
    height: 30px;
  }
`;

export const SelectBox = styled.select`
  border-radius: 10px;
  border: 1px solid #ededed;
  height: 52px;
  padding: 0 20px;
  &:focus {
    outline: none;
    border: 1px solid #ededed !important;
    box-shadow: none;
  }
  @media screen and (max-width: 767px) {
    height: 30px;
  }
`;

export const EditProfileContainer = styled.div`
  input[type="text"],
  input[type="password"] {
    width: 100%;
  }
  ul {
    li {
      display: flex;
      align-items: center;
      min-height: 84px;
      padding: 10px 20px;
      border-bottom: 1px solid #eee;
      button {
        border-radius: 10px;
        border: 1px solid #ededed;
        height: 52px;
        background-color: #fafafa;
        color: #a8aaa8;
      }
      .tit {
        width: 150px;
      }
      .cont {
        width: calc(100% - 150px);
      }
      &.adres,
      &.passwordConfirm,
      &.email {
        .cont {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          input[type="text"]:first-child,
          input[type="password"]:first-child {
            width: calc(100% - 130px);
          }
          button {
            width: 120px;
          }
        }
      }
      &.moblphonNo,
      &.tel {
        button {
          width: 120px;
        }
        .cont {
          display: flex;
          gap: 10px;
          input[type="text"],
          select {
            width: calc((100% - 150px) / 3);
          }
        }
      }
    }
  }
  .submit {
    display: flex;
    justify-content: space-between;
    margin-top: 70px;
    button {
      width: 190px;
      height: 60px;
      border-radius: 8px;
      background: transparent;
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
    > button:nth-child(2) {
      color: #9c9c9c;
      border: 1px solid #ededed;
    }
    div {
      width: 80%;
      display: flex;
      justify-content: center;
      button {
        &:nth-child(1) {
          background: #c7002e;
          border: 1px solid #c7002e;
          color: #fff;
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
  }
  @media screen and (max-width: 767px) {
    ul {
      margin-top: 20px;
      li {
        flex-wrap: wrap;
        min-height: auto;
        border-bottom: none;
        padding: 0;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .tit,
        .cont {
          width: 100%;
        }
        .tit {
          margin-bottom: 5px;
        }
        &.adres .cont button,
        &.passwordConfirm .cont button {
          height: 30px;
          background: #000;
          color: #fff;
        }
      }
    }
    .actions {
      justify-content: center;
      gap: 10px;
      button {
        height: 30px;
      }
      > button {
        max-width: 200px;
        width: calc(50% - 5px);
      }
      div {
        width: calc(50% - 5px);
        max-width: 200px;
        display: block;
        button {
          width: 100%;
        }
      }
    }
  }
`;

export const AddressesContainer = styled.div`
  .addresses {
    > li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      text-align: center;
      min-height: 70px;
      border-bottom: 1px solid #eaeaea;
      padding: 10px 0;
      gap: 10px;
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      > * {
        &:nth-child(1) {
          width: 5%;
        }
        &:nth-child(2) {
          width: 20%;
          display: flex;
          align-items: center;
          gap: 10px;
          padding-left: 10px;
          strong {
            background: #f5f5f5;
            border-radius: 2px;
            color: #d3233a;
            padding: 5px 15px;
            font-size: 10px;
            font-weight: normal;
          }
        }
        &:nth-child(3) {
          width: calc(60% - 30px);
          text-align: left;
          span {
            display: block;
            white-space: pre-line;
            &:nth-child(2) {
              margin-top: 5px;
              color: #555;
            }
          }
        }
        &:nth-child(4) {
          width: 15%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          button {
            color: #898989;
            background: transparent;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .addresses > li {
      flex-wrap: wrap;
      min-height: auto;
      text-align: left;
      padding: 20px 0;
      font-size: 14px;
      position: relative;
      > :nth-child(1) {
        display: none;
      }
      > :nth-child(2) {
        padding-left: 0;
        margin-bottom: 10px;
        width: calc(100% - 70px);
        span {
          font-weight: 700;
        }
        strong {
          padding: 2px 5px;
        }
      }
      > :nth-child(3) {
        margin-bottom: 5px;
        white-space: pre-wrap;
      }
      > :nth-child(3) {
        width: 100%;
        color: #888;
      }
      > :nth-child(4) {
        width: 70px;
        position: absolute;
        top: 20px;
        right: 0;
        color: #888;
      }
    }
  }
`;

export const AddressModalContainer = styled.div`
  .checkInfo {
    display: flex;
    align-items: center;
    gap: 10px;
    &:nth-child(2) {
      padding-bottom: 10px;
      margin-bottom: 20px;
      border-bottom: 1px solid #b1b1b1;
    }
    &:last-child {
      margin-top: 20px;
    }
    p {
      color: #a8aaa8;
    }
  }
  ul {
    li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      input[type="text"] {
        width: 100%;
      }
      &:last-child {
        margin-bottom: 0;
      }
      &.address .cont {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        input[type="text"] {
          &:first-child {
            width: calc(100% - 100px);
          }
        }
        button {
          background: #fff;
          border: 1px solid #f1f1f1;
          color: #a8aaa8;
          border-radius: 10px;
          width: 90px;
        }
      }
      &.phone .cont {
        display: flex;
        align-items: center;
        gap: 10px;
        select,
        input[type="text"] {
          width: calc((100% - 20px) / 3);
        }
      }
      .tit {
        width: 130px;
      }
      .cont {
        width: calc(100% - 130px);
      }
    }
  }
  @media screen and (max-width: 767px) {
    .form {
      display: flex;
      flex-direction: column;
      ul {
        margin: 30px 0;
        li {
          flex-wrap: wrap;
          .tit {
            margin-bottom: 5px;
          }
          .tit,
          .cont {
            width: 100%;
          }
        }
      }
    }
    .checkInfo:nth-child(2) {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
    .checkInfo {
      order: 1;
    }
    .submit {
      border-color: #c7002e;
      background: #c7002e;
      color: #fff;
    }
  }
`;

export const EditOptionModalContainer = styled.div`
  ul {
    height: calc(100% - 50px);
    overflow-y: auto;
    li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      input[type="text"] {
        width: 100%;
      }
      &:last-child {
        margin-bottom: 0;
      }
      .tit {
        width: 130px;
      }
      .tit ~ select {
        width: calc(100% - 130px);
      }
    }
  }
  .checkInfo {
    display: flex;
    align-items: center;
    gap: 10px;
    &:nth-child(2) {
      padding-bottom: 10px;
      margin-bottom: 20px;
      border-bottom: 1px solid #b1b1b1;
    }
    &:last-child {
      margin-top: 20px;
    }
    p {
      color: #a8aaa8;
    }
  }
  select {
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    ul {
      margin: 30px 0;
      li {
        flex-wrap: wrap;
        .tit {
          margin-bottom: 5px;
          width: 100%;
        }
        .tit ~ select {
          width: 100%;
        }
      }
    }
    .form {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const OrderContainer = styled.div`
  .contents {
    display: flex;
    justify-content: space-between;
    .info {
      max-width: 600px;
      width: 60%;
      > div {
        border-bottom: 1px solid #e0e0e0;
        padding-bottom: 20px;
        margin-bottom: 20px;
      }
    }
  }
  p.title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      border: 1px solid #dddddd;
      background: transparent;
      border-radius: 5px;
      width: 60px;
      height: 25px;
      font-size: 12px;
    }
  }
  @media screen and (max-width: 767px) {
    .contents {
      display: block;
      .info {
        max-width: 100%;
        width: 100%;
      }
    }
    p.title {
      font-size: 18px;
    }
  }
`;

export const OrderAddress = styled.div`
  button.addr {
    width: 160px;
    height: 36px;
    border-radius: 5px;
    border: 1px solid #ddd;
    background: #fff;
    font-size: 12px;
  }
  .address {
    position: relative;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        width: calc(100% - 170px);
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        strong {
          max-width: calc(100% - 85px);
          font-size: 22px;
          font-weight: 700;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        strong ~ span {
          background: #f5f5f5;
          width: 75px;
          height: 23px;
          color: #d3233a;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2px;
          font-size: 10px;
        }
        span {
          font-size: 14px;
          color: #999;
        }
      }
    }
    .info {
      font-size: 16px;
      margin: 40px 0;
      span {
        display: block;
        &:not(:last-child) {
          margin-bottom: 15px;
        }
      }
    }
    .memo {
      font-size: 14px;
      select,
      textarea {
        width: 100%;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        &:focus {
          outline: none;
          border: 1px solid #e0e0e0 !important;
          box-shadow: none;
        }
      }
      select {
        padding: 0 10px;
        height: 36px;
      }
      textarea {
        padding: 10px;
        margin-top: 10px;
        height: 130px;
        resize: none;
      }
    }
  }
  .form {
    font-size: 14px;
    li {
      display: flex;
      align-items: center;
      .tit {
        width: 100px;
      }
      .cont {
        width: calc(100% - 100px);
      }
    }
  }

  @media screen and (max-width: 767px) {
    .address {
      .title p {
        width: calc(100% - 80px);
        strong {
          font-size: 20px;
        }
      }
      .info {
        margin: 20px 0;
        span:not(:last-child) {
          margin-bottom: 5px;
        }
      }
    }
    button.addr {
      width: 75px;
      height: 23px;
      font-size: 10px;
      color: #8f908f;
    }
  }
`;

export const SelectAddressModalContainer = styled.div`
  ul {
    height: calc(100% - 50px);
    overflow: auto;
    li {
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
        border-bottom: none;
      }
      .info {
        display: flex;
        align-items: center;
        gap: 10px;
        label {
          display: flex;
        }
        strong {
          font-size: 18px;
        }
      }
      > p {
        margin: 10px 0;
        span {
          display: block;
          &:nth-child(1) {
            margin-bottom: 5px;
          }
        }
      }
      button {
        width: 100px;
        height: 36px;
        border-radius: 5px;
        border: 1px solid #ddd;
        background: #fff;
        font-size: 14px;
        margin-left: auto;
        display: block;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .form {
      display: flex;
      flex-direction: column;
      ul {
        margin: 30px 0;
        li {
          .info strong {
            font-size: 14px;
          }
          button {
            font-size: 12px;
          }
        }
      }
    }
  }
`;

export const OrderProductContainer = styled.div`
  .groups {
    > div {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    strong {
      font-weight: normal;
      margin-bottom: 10px;
      display: block;
      font-size: 16px;
    }
    ul li {
      display: flex;
      align-items: center;
      gap: 30px;
      font-size: 16px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        width: 80px;
        height: 80px;
        border-radius: 2px;
      }
      .product {
        width: calc(100% - 110px);
        p {
          &:nth-child(1) {
            font-weight: 300;
          }
          &.options {
            color: #555;
          }
          &:nth-child(3) {
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .groups ul li {
      gap: 20px;
      font-size: 14px;
      img {
        width: 65px;
        height: 65px;
      }

      .product {
        width: calc(100% - 85px);
      }
    }
  }
`;

export const PaymentMethodContainer = styled.div`
  font-size: 14px;
  ul {
    display: flex;
    align-items: center;
    gap: 8px;
    li {
      font-size: 15px;
      font-weight: 300;
      width: calc(100% / 4 - 6px);
      border-radius: 4px;
      line-height: 56px;
      text-align: center;
      height: 56px;
      background-color: rgb(255, 255, 255);
      border: 1px solid rgb(229, 232, 235);
      color: rgb(78, 89, 104);
      cursor: pointer;
      &.active {
        background-color: rgb(255, 255, 255);
        border: 1px solid rgb(25, 31, 40);
        font-weight: 700;
        color: rgb(25, 31, 40);
      }
    }
  }
  .toss {
    &.active {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid rgb(229, 232, 235);
    }
    &.inactive {
      height: 0;
      overflow: hidden;
    }
  }
`;

export const CashReceiptContainer = styled.div`
  font-size: 14px;
  div {
    display: flex;
    justify-content: space-between;
  }
`;

export const OrderTotal = styled.div`
  max-width: 350px;
  width: 30%;
  > div {
    font-size: 14px;
    padding: 26px 16px;
    border: 1px solid #eaeaea;
    border-radius: 10px;
    p {
      font-size: 18px;
      margin-bottom: 20px;
      font-weight: 600;
    }
    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      &:last-child {
        margin-top: 50px;
        padding-top: 10px;
        border-top: 1px solid #eaeaea;
        margin-bottom: 0;
        .tit {
          font-weight: 700;
        }
      }
    }
  }
  > button {
    margin-top: 20px;
    width: 100%;
    height: 46px;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    background: #000;
    cursor: not-allowed;
    &.active {
      cursor: pointer;
      background: #d3233a;
    }
  }
  @media screen and (max-width: 767px) {
    max-width: 100%;
    width: 100%;
    > div {
      padding: 0;
      border: none;
    }
  }
`;

export const ModalContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  font-size: 16px;
  .modal {
    width: 570px;
    height: 630px;
    border-radius: 10px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .close {
      font-size: 24px;
      color: #a9a9a8;
    }
  }
  .form {
    padding: 30px;
    height: calc(100% - 60px);
  }
  .submit {
    height: 60px;
    border-top: 1px solid #e7e7e7;
    background: transparent;
    width: 100%;
    color: #d3233a;
  }
  @media screen and (max-width: 767px) {
    background: #fff;
    font-size: 14px;
    .form {
      padding: 20px;
    }
    .modal {
      width: 100vw;
      height: 100vh;
      border-radius: 0;
    }
    .submit {
      border-color: #c7002e;
      background: #c7002e;
      color: #fff;
    }
  }
`;

export const CancelModalContainer = styled.div`
  .form > div:nth-child(2) {
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100% - 50px);
  }
  .slideWrapper {
    flex-flow: row nowrap;
    display: flex;
    flex: 1;
    width: 100%;
    transition: transform 0.5s ease;
    height: 100%;
    overflow: hidden;
    margin: auto;
    .slideContent {
      flex: 0 0 50%;
      transform: translateX(0);
      flex-basis: 100%;
      flex-shrink: 0;
      transition: 0.3s;
      width: 100%;
      overflow-x: hidden;
      height: 100%;
      box-sizing: border-box;
      overflow: hidden auto;
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.7);
        border-radius: 10px;
      }
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
  }
`;

export const ReasonContainer = styled.div`
  span {
    margin-bottom: 20px;
  }
  select {
    display: block;
    margin: 30px 0;
    width: 100%;
  }
  textarea {
    border-radius: 10px;
    border: 1px solid #ededed;
    height: 100px;
    padding: 20px;
    resize: none;
    width: 100%;
    &:focus {
      border: 1px solid #ededed !important;
      box-shadow: none;
    }
  }
`;

export const SelectProductList = styled.ul`
  margin-top: 20px;
  li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 70px;
      height: 70px;
      border-radius: 5px;
    }
    .productInfo {
      width: calc(100% - 110px);
      p:nth-child(2) {
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }
`;

export const OrderDeliveryContainer = styled.div`
  letter-spacing: -1px;
  .contents {
    display: flex;
    flex-wrap: wrap;
    gap: 50px;
    margin-top: 40px;
  }
  .section {
    width: calc(50% - 25px);
    button.btn {
      width: 100%;
      border: 1px solid #dddddd;
      border-radius: 5px;
      height: 36px;
      font-size: 12px;
      letter-spacing: -1px;
      background: #fff;
    }
  }
  .courier {
    font-size: 14px;
    p {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    ~ button {
      margin-top: 30px;
    }
  }

  @media screen and (max-width: 1050px) {
    .contents {
      flex-direction: column-reverse;
      .section {
        width: 100%;
      }
    }
    .info {
      font-size: 20px;
      margin: 30px 0;
    }
  }
  @media screen and (max-width: 767px) {
    .contents {
      gap: 40px;
    }
    .info {
      font-size: 18px;
      margin: 20px 0;
    }
  }
`;

export const StatusStepperContainer = styled.ul`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #818181;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e0e0e0;
  &.SHIPPING_START {
    li:nth-child(1) {
      div {
        background: #d3233a;
      }
      span {
        color: #000;
        font-weight: 600;
      }
    }
  }
  &.SHIPPING {
    li:nth-child(1),
    li:nth-child(2) {
      div {
        background: #d3233a;
      }
      span {
        color: #000;
      }
    }
    li:nth-child(2) span {
      font-weight: 600;
    }
  }
  &.DELIVERED {
    li {
      div {
        background: #d3233a;
      }
      span {
        color: #000;
      }
      &:last-child span {
        font-weight: 600;
      }
    }
  }
  li {
    width: calc((100% - 8px) / 3);
  }
  div {
    height: 4px;
    margin-bottom: 4px;
    background: #d9d9d9;
    border-radius: 1px;
  }
  span {
    font-size: 13px;
  }
`;

export const DeliveryProductsContainer = styled.div`
  font-size: 16px;
  > div {
    .tit strong {
      font-size: 18px;
    }
    button {
      display: flex;
      align-items: center;
      color: #d3233a;
    }
  }
  ul {
    margin-bottom: 20px;
    &:last-child {
      border-bottom: 1px solid #e0e0e0;
      padding-bottom: 30px;
    }
    li {
      display: flex;
      align-items: center;
      gap: 30px;
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        width: 80px;
        height: 80px;
        border-radius: 2px;
      }
      .productInfo {
        width: calc(100% - 110px);
      }
      p {
        margin-bottom: 5px;
        &:nth-child(2) {
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    ul {
      margin-top: 10px;
      li {
        gap: 10px;
        img {
          width: 60px;
          height: 60px;
        }
        .productInfo {
          width: calc(100% - 70px);
          font-size: 14px;
        }
      }
    }
  }
`;

export const DeliveryLogsContainer = styled.div`
  color: #919391;
  font-size: 14px;
  ul {
    margin-top: 30px;
  }
  li {
    padding-left: 25px;
    padding-bottom: 14px;
    position: relative;
    &:last-child {
      &::before {
        display: none;
      }
      padding-bottom: 0;
    }
    &:nth-child(1) {
      .dot {
        border-color: #d3233a;
      }
      color: #000;
    }
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 8px;
      transform: translateX(-50%);
      width: 2px;
      height: 100%;
      background: #e0e0e0;
    }
    .dot {
      position: absolute;
      top: 0;
      left: 0;
      width: 16px;
      height: 16px;
      display: flex;
      border: 3px solid #e0e0e0;
      background: #fff;
      border-radius: 50%;
    }
  }
  > p {
    margin-top: 30px;
  }
  @media screen and (max-width: 1050px) {
    .btn {
      display: none;
    }
    ul {
      /* margin-top: 0; */
    }
  }
  @media screen and (max-width: 767px) {
    > p {
      font-size: 12px;
    }
  }
`;

export const OrderProgressContainer = styled.div`
  border: 1px solid #ddd;
  border-radius: 10px;
  .info {
    padding: 20px;
    text-align: center;
    font-size: 18px;
    border-bottom: 1px solid #ddd;
  }
  ul {
    padding: 20px;
    display: flex;
    align-items: center;
  }
  li {
    width: calc(100% / 5);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    gap: 10px;
    &.active {
      &:not(:first-child)::before {
        background: rgb(211, 35, 58);
      }
      ::after {
        border-color: rgb(211, 35, 58);
      }
    }
    svg {
      display: block;
      margin: 0;
      font-size: 30px;
    }
    span {
      font-size: 14px;
    }
    .dot {
      width: 20px;
      height: 20px;
    }
    &::after {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 3px solid #ddd;
      background: #fff;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
    }
    &:not(:first-child)::before {
      content: "";
      position: absolute;
      top: calc(100% - 10px);
      left: 0;
      width: 100%;
      height: 2px;
      background-color: #ddd;
      transform: translateY(-50%) translateX(-50%);
      z-index: 0;
    }
  }
`;

export const FailContainer = styled.div`
  text-align: center;
  .tit {
    display: block;
    font-size: 30px;
    margin-bottom: 30px;
  }
  p {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
